<template>
  <div class="columns">
    <div class="column">
      <div class="timeline" v-if="hasAuditLogs">
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
        <br/>
        <div class="timeline-header">
          <span class="tag is-small is-primary">Newer</span>
        </div>
        <div class="timeline-item" v-for="auditLog in limitBy(this.creditAppAuditLogs, this.auditLogRange)" :key="auditLog.id">
          <div class="timeline-marker is-image is-32x32">
            <img src="https://bulma.io/assets/images/placeholders/32x32.png">
          </div>
          <div class="timeline-content" style="width: 100%;">
            <p class="heading is-inline-block" :title="auditLog.createdAt | formatDate">{{ auditLog.createdAt | formatHumanDate }} - {{ auditLog.changedBy }}</p>
            <p class="is-size-7 note-item">
              <span v-if="isHtml" v-html="auditLog.fieldChanges"></span>
              <span v-else>{{auditLog.fieldChanges}}</span>
            </p>
          </div>
        </div>
        <header class="timeline-header">
          <span class="tag is-small is-primary" @click="showMoreAuditLogs" v-if="hasMoreAuditLogs">Older...</span>
          <span class="tag is-small is-primary" @click="showMoreAuditLogs" v-else>Older</span>
        </header>
      </div>
      <div v-else class="column is-12 is-size-7 has-text-info">
        <p>
          There are no credit application changes available
        </p>
      </div>
    </div>
    <b-loading :is-full-page="false" :active.sync="isSaving" :canCancel="false"></b-loading>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import utilitiesMixin from '@/mixins/generic/utilities'

export default {
  mixins: [utilitiesMixin, Vue2Filters.mixin],
  name: 'CreditAppAuditTimeline',
  components: {
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      creditAppAuditLogs: this.value,
      defaultAuditLogRange: 5,
      auditLogRange: 5,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: ''
    }
  },
  computed: {
    hasAuditLogs: function () {
      return this.creditAppAuditLogs && this.creditAppAuditLogs.length > 0
    },
    hasMoreAuditLogs: function () {
      return this.creditAppAuditLogs.length > this.auditLogRange
    }
  },
  methods: {
    showMoreAuditLogs: function () {
      this.auditLogRange += this.defaultAuditLogRange
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.creditAppAuditLogs = newValue
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .box {
    background-color: #f6f8fa;
  }

  .pointer {
    cursor: pointer;
  }

</style>
